import React, { FC } from 'react';
import { Col, Row } from 'antd';
import { CollapseSvg, SignedSvg } from '../../../../icons';
import { CollapseButton, CollapsibleTextContainer } from '../../../../styles/styled';
import { CloseCollapseTag } from '../../../NewApplicationPage/components/BookRegistrationComponent/styled';
import { BookTextbookType } from '../../../NewApplicationPage/types';
import { TextBookContainer, TextBookBlock, TextBookInfoContainer, SignedElementsContainer, InfoLayout } from './styled';

type TextBookProps = {
  book: BookTextbookType;
  isCollapsed: boolean;
  setCollapsed: () => void;
  language: string;
};

export const TextBook: FC<TextBookProps> = ({ language, book, isCollapsed, setCollapsed }) => {
  return (
    <TextBookContainer>
      <CollapsibleTextContainer onClick={() => setCollapsed()}>
        {book.title}
        <CloseCollapseTag>
          <CollapseButton onClick={() => setCollapsed()}>{isCollapsed ? '—' : <CollapseSvg />}</CollapseButton>
        </CloseCollapseTag>
      </CollapsibleTextContainer>
      {isCollapsed && (
        <TextBookInfoContainer>
          <TextBookBlock>
            <div className="text layout">Правообладатель *</div>
            <div className="text">{book?.right_holder}</div>
          </TextBookBlock>
          <TextBookBlock>
            <div className="text layout">Фио автора (авторского коллектива) *</div>
            <div className="text">{book?.author}</div>
          </TextBookBlock>
          <TextBookBlock>
            <div className="text layout">Язык издания учебника</div>
            <div className="text">{language}</div>
          </TextBookBlock>
          <TextBookBlock>
            <div className="text layout">Учебный предмет</div>
            <div className="text">{book?.subject_general?.title}</div>
          </TextBookBlock>
          <TextBookBlock>
            <div className="text layout">Класс</div>
            <div className="text">{book?.school_classes[0]?.title}</div>
          </TextBookBlock>
          <TextBookBlock>
            <div className="text layout">Наименование учебника</div>
            <div className="text lined">{book?.title}</div>
          </TextBookBlock>
          <TextBookBlock>
            <div className="text layout">Год выпуска учебника</div>
            <div className="text">{book?.year}</div>
          </TextBookBlock>
          {book?.region?.title && (
            <TextBookBlock>
              <div className="text layout">Учебник, учитывающий региональные особенности</div>
              <div className="text">{book?.region?.title}</div>
            </TextBookBlock>
          )}
          <TextBookBlock />
          {book?.subject_series_textbooks_titles && (
            <TextBookBlock>
              <div className="text layout">Учебник относится к завершенной предметной линии</div>
              <div className="text">{book?.subject_series_textbooks_titles}</div>
            </TextBookBlock>
          )}
          {book?.public_expertise_score !== 0 && <TextBookBlock />}
          <InfoLayout>Предоставление документов в печатном формате</InfoLayout>
          <SignedElementsContainer>
            {book.hard_copies_present && (
              <div className="text">
                <SignedSvg />
                Учебник предоставлен в печатном формате
              </div>
            )}
            {book.adaptive && (
              <div className="text">
                <SignedSvg />
                Учебник для реализации адаптированных общеобразовательных программ
              </div>
            )}
            {book.is_part_of_subject_series && (
              <div className="text">
                <SignedSvg />
                Учебник относится к завершенной предметной линии
              </div>
            )}
            {book.in_depth_study && (
              <div className="text">
                <SignedSvg />
                Учебник для общеобразовательных программ с углубленным изучением учебных предметов, предметных областей
              </div>
            )}
            {book.cartographic_material && (
              <div className="text">
                <SignedSvg />
                Наличие картографического материала
              </div>
            )}
            {book.public_expertise && (
              <div className="text">
                <SignedSvg />
                Учебник направлен в печатном виде
              </div>
            )}
            {book.installation_manual_present && (
              <div className="text">
                <SignedSvg />
                Инструкция по установке, настройке и использованию электронной формы учебника (в печатной и электронной
                формах)
              </div>
            )}
            {book.teacher_guidelines_present && (
              <div className="text">
                <SignedSvg />
                Методическое пособие для учителя направлено в печатном виде
              </div>
            )}
            {book.region?.id && (
              <div className="text">
                <SignedSvg />
                Учебник, учитывающий региональные особенности
              </div>
            )}
          </SignedElementsContainer>
          <InfoLayout>Предоставление документов в электронном формате</InfoLayout>
          {book.file_textbook_endpapers && book.file_textbook_endpapers.length > 0 && (
            <InfoLayout size={12} color="#7594b9" weight={400}>
              Форзац учебника
              <a href={book.file_textbook_endpapers[0].file_path} target="_blank" rel="noreferrer" className="link">
                Просмотреть
              </a>
            </InfoLayout>
          )}
          {book.file_textbook && (
            <InfoLayout size={12} color="#7594b9" weight={400}>
              Учебник
              <a href={book.file_textbook.file_path} target="_blank" rel="noreferrer" className="link">
                Просмотреть
              </a>
            </InfoLayout>
          )}
          {book?.text_book_edu_man?.map(
            (el) =>
              el.file?.file_path && (
                <InfoLayout size={12} color="#7594b9" weight={400}>
                  {`Учебное пособие ${el.title}`}
                  <a href={el.file.file_path} target="_blank" rel="noreferrer" className="link">
                    Просмотреть
                  </a>
                </InfoLayout>
              ),
          )}
          {book.file_guideline && (
            <InfoLayout size={12} color="#7594b9" weight={400}>
              Методическое пособие учебника
              <a href={book.file_guideline.file_path} target="_blank" rel="noreferrer" className="link">
                Просмотреть
              </a>
            </InfoLayout>
          )}
          {book.file_instruction && (
            <InfoLayout size={12} color="#7594b9" weight={400}>
              Инструкция по установке, настройке и использованию электрноой формы учебника
              <a href={book.file_instruction.file_path} target="_blank" rel="noreferrer" className="link">
                Просмотреть
              </a>
            </InfoLayout>
          )}
          {book.file_conclusion && (
            <InfoLayout size={12} color="#7594b9" weight={400}>
              Файл общественной экспертизы
              <a href={book.file_conclusion.file_path} target="_blank" rel="noreferrer" className="link">
                Просмотреть
              </a>
            </InfoLayout>
          )}

          {book?.public_expertise_score !== 0 && (
            <InfoLayout size={12} color="#7594b9" weight={400}>
              <div className="text layout">Суммарный балл по результатам общественной экспертизы</div>
              <div className="dark">{book?.public_expertise_score}</div>
            </InfoLayout>
          )}

          <InfoLayout size={12} color="#7594b9" weight={400}>
            Дополнительные материалы учебника
            {book.file_textbook_additional_materials && (
              <Row gutter={[20, 20]}>
                {book.file_textbook_additional_materials.map((el, key) => (
                  <Col key={key}>
                    <a href={el.file_path} target="_blank" rel="noreferrer" className="link">
                      Просмотреть
                    </a>
                  </Col>
                ))}
              </Row>
            )}
          </InfoLayout>
          <Row style={{ width: '100%' }} gutter={[20, 20]}>
            <Col span={12}>
              <InfoLayout size={12} color="#7594b9" weight={400}>
                Ссылка на электронную форму учебника
              </InfoLayout>
              <InfoLayout size={12} color="black" weight={400}>
                {book.comment && book.comment.length > 0 ? book.comment : 'нет'}
              </InfoLayout>
            </Col>
            <Col span={12}>
              <InfoLayout size={12} color="#7594b9" weight={400}>
                Ссылка на электронную форму учебника
              </InfoLayout>
              <InfoLayout size={12} color="black" weight={400}>
                {book.link_to_textbook && book.link_to_textbook.length > 0 ? book.link_to_textbook : 'нет'}
              </InfoLayout>
            </Col>
          </Row>
        </TextBookInfoContainer>
      )}
    </TextBookContainer>
  );
};
